module.exports = __webpack_public_path__ + "img/02. 稅創藝.7288db68.jpg";